<template>
<v-container fluid>
<v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="-1"
  absolute
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>

  <v-layout class="main-layout">
  <v-flex xs12>
    <v-card>
      <v-card-text>
        <v-layout>
          <v-flex xs3>
            <span class="accent--text" style="font-size: 14px; font-weight:700;"> Exception Report </span>
            <v-spacer v-if="userId"></v-spacer>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
          </v-flex>
          <v-spacer>
          </v-spacer>
          <v-flex xs3>
            <v-text-field label="Search" v-model="search">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="millingCharges"
          :items-per-page="5"
          :search="search"
          class="elevation-1"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>

  </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
	name: 'catalogueupload',
	data: function () {
		return {
			gradeDisabled: true,
			millingCharges: [],
			editFarmerType: {},
			editCoffeeType: {},
			editGrade: {},
			editStatus: '',
			cherryRateTemp: { rate: 0, name: 'hello' },
			headers: [
				{ text: 'ESLIP', value: 'e_SLIP_NUMBER' },
				{ text: 'ESLIP Amount', value: 'e_SLIP_AMOUNT' },
				{ text: 'Invoice Number', value: 'id' },
				{ text: 'Invoice Status', value: 'invoice_STATUS' },
				{ text: 'Date Paid', value: 'date_PAID' },
				{ text: 'Buyer', value: 'buyer_DETAILS' },
				// { text: 'Narration', value: 'narration' },
				{ text: 'Exception reason', value: 'error' }
			],
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			file: '',
			files: [],
			pagination: { sortBy: 'id', descending: true },
			search: '',
			permissions: [],
			previewLoading: false,
			approveloading: false,
			declineloading: false,
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			confirmDialog: false,
			confirmFile: {},
			confirmMessage: '',
			action: '',
			rateLimitDialog: false,
			editRateLimitDialog: false,
			approveRateLimitDialog: false,
			userID: 0,
			organisationType: null
		}
	},
	mounted () {
		this.getBrokerReport()
		this.permissions = store.state.user.roleId.permissions
	},
	watch: {
		files () {
			this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		...mapState({ user: state => state.user }),
		canApproveCatalogue: function () {
			return this.hasPerm('CAN_APPROVE_CATALOGUE')
		},
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.files.filter(file => { return file.fileName.toLowerCase().includes(this.search.toLowerCase()) })
			}
		},
		userId: function () {
			if (this.user) {
				console.log('user - ', this.user)
				this.organisationType = this.user.organisation.organisationType.name
				this.userID = this.user.id
				return this.user.id
			}
			return 0
		}
	},
	methods: {
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		canBeDeclined (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		openCreateDialog () {
			this.rateLimitDialog = true
		},
		getBrokerReport () {
			http.get(config.serverURI + '/miller/findExceptionalReport')
				.then(response => {
					const items = response.data
					items.forEach(item => {
						item.e_SLIP_AMOUNT = this.truncateDecimal(item.e_SLIP_AMOUNT)
						item.date_PAID = this.formatDate(item.date_PAID)
					})
					this.millingCharges = items
					console.log('RR -> ', response.data)
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		exportToExcel () {
			const exportData = this.millingCharges.map(miller => ({
				'Eslip Number': miller.e_SLIP_NUMBER,
				'ESLIP Amount': miller.e_SLIP_AMOUNT,
				'Invoice Number': miller.id,
				'Invoice Status': miller.invoice_STATUS,
				'Date Paid': miller.date_PAID,
				Buyer: miller.buyer_DETAILS,
				// Narration: miller.narration,
				'Exception reason': miller.error
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'exceptionalReportData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'exceptional_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		truncateDecimal (value) {
			if (!isNaN(value)) {
				// Check if the number is a whole number
				if (Number.isInteger(value)) {
					return value.toString() // Return as a string to avoid displaying trailing .00
				} else {
					return parseFloat(value).toFixed(2) // Truncate to 2 decimal places
				}
			}
			return value
		},
		formatDate (timestamp) {
			const date = new Date(timestamp)
			return date.toLocaleDateString() // Formats date to a string in mm/dd/yyyy format
		}
	}
}

</script>
<style>
.main-layout {
  margin-top: 15px;
}
.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn{
  padding: 10px;
  margin: 5px;
}
.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}
.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table  tbody  tr >  td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}
.pagination {
  background-color: red;
}
.paginationtext {
  color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}
.pagination>li.active>.page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col{
  border: 1px solid brown;
}
</style>
